/* eslint-disable */
"use strict";

var config, service, tabacchi;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  tabacchi = config.VUE_APP_MOL_S_TABACCHI
}

exports.generaOrdine = async function(data, modalita) {
  if (!config || !service) {
    await getConfigFile();
  }
  // modalita: anteprima / definitivo
  const response = await fetch(`${service}/${tabacchi}/ordine/${modalita}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.infoProdotto = async function(data) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${tabacchi}/ordine/prodotto/info`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};
